var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcIcosahedron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05552 2L15.1036 5.57499V12.725L9.05552 16.3L3.00745 12.725V5.57499L9.05552 2Z",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0556 5.32617L12.3812 10.9796H5.39746L9.0556 5.32617Z",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0418 5.65625L12.3814 10.9772M12.3814 10.9772L9.08728 16.2982M12.3814 10.9772L15.0418 12.6399",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05603 2L9.05603 5.32557",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08716 16.2992L5.39756 10.9782L3 5.57422",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.67189L8.88942 5.32617L15.0417 5.65873",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32397 12.5144L5.42692 10.832",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIcosahedron);
export default __webpack_public_path__ + "static/media/ic_icosahedron.68897d7cc6a917f6297903998dd429c7.svg";
export { ForwardRef as ReactComponent };